<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model :model="dynamicValidateForm" ref="dynamicValidateForm">
        <a-form-model-item
          style="text-align: center"
          prop="name"
          :rules="{
            required: true,
            message: '请输入大标题！',
            trigger: 'change'
          }"
        >
          <a-input
            style="text-align: center;width: 80%; font-size: 20px"
            size="large"
            placeholder="请输入大标题"
            v-model="dynamicValidateForm.name"
          />
        </a-form-model-item>
        <div
          class="item-form"
          v-for="(domain, index) in dynamicValidateForm.listQuestionOptionDto"
          :key="index"
        >
          <div @mouseenter="selectIndex = index" @mouseleave="selectIndex = ''">
            <a-row type="flex">
              <a-col style="width: 50px;">
                <span style="font-size: 16px;">Q{{ index + 1 }}</span>
                <p style="font-size: 12px;">
                  (<span v-if="domain.questionType == '3'">文本</span
                  ><span v-else>{{
                    domain.questionType == '1' ? '单选' : '多选'
                  }}</span
                  >题)
                </p>
              </a-col>
              <a-col style="width: calc(100% - 60px)">
                <a-form-model-item
                  class="questionName-item"
                  :prop="'listQuestionOptionDto.' + index + '.questionName'"
                  :rules="{
                    required: true,
                    message: '请输入标题！',
                    trigger: 'change'
                  }"
                >
                  <a-input
                    ref="input"
                    v-if="editingIndex === 'title' + index"
                    v-model="domain.questionName"
                    @blur="editingIndex = ''"
                    placeholder="请输入标题"
                  />
                  <span
                    style="padding:0 12px;font-weight: 600;display:inline-block"
                    v-else
                    @click="inputFocus('title' + index)"
                  >
                    <span v-if="domain.questionName">{{
                      domain.questionName
                    }}</span>
                    <span v-else-if="domain.questionType == 3">文本题</span>
                    <span v-else>{{
                      domain.questionType == '1' ? '单选题' : '多选题'
                    }}</span>
                  </span>
                </a-form-model-item>

                <!-- 单选  === 1-->
                <a-form-model-item v-if="domain.questionType != '3'">
                  <div
                    @mouseenter="selectOneIndex = indexInner"
                    v-for="(item, indexInner) in domain.questionOption"
                    :key="indexInner"
                  >
                    <a-input
                      ref="input"
                      v-if="
                        editingIndex === indexInner && selectIndex === index
                      "
                      v-model="domain.questionOption[indexInner]"
                      class="item-input"
                      @blur="editingIndex = ''"
                      :placeholder="'选项' + (indexInner + 1)"
                    />
                    <span
                      style="padding:0 12px"
                      v-else
                      @click="inputFocus(indexInner)"
                      >{{ item ? item : '选项' + (indexInner + 1) }}</span
                    >
                    <a-button
                      v-if="
                        selectIndex === index && selectOneIndex === indexInner
                      "
                      style="margin-left: 100px"
                      type="link"
                      @click.prevent="
                        removeOneItem(domain, indexInner, domain.questionType)
                      "
                    >
                      删除
                    </a-button>
                  </div>
                </a-form-model-item>

                <!-- @mouseleave="selectIndex = ''" @mouseleave="selectOneIndex = '';"  -->

                <a-form-model-item
                  v-if="domain.questionType == '3'"
                  :prop="'listQuestionOptionDto.' + index + '.questionOption'"
                  :rules="{
                    required: true,
                    message: 'domain can not be null',
                    trigger: 'blur'
                  }"
                >
                  <a-textarea
                    style="border: 1px solid #eaeaea;"
                    v-model="domain.questionOption[0]"
                    placeholder="请输入内容"
                  />
                </a-form-model-item>

                <a-button
                  v-if="
                    dynamicValidateForm.listQuestionOptionDto[index].type !=
                      'text'
                  "
                  @click="addOneItem(domain, index)"
                >
                  <a-icon type="plus" /> 添加
                </a-button>
                &nbsp;
                <a-button
                  v-if="
                    dynamicValidateForm.listQuestionOptionDto[index].type !=
                      'text'
                  "
                  @click="removeItem(index)"
                >
                  <a-icon type="delete" /> 删除
                </a-button>
              </a-col>
            </a-row>
          </div>
        </div>
        <a-form-model-item style="text-align: center;">
          <div v-show="showAddOp" class="add-options">
            <a-button @click="addQuestion('1')">单选题</a-button>&nbsp;
            <a-button @click="addQuestion('2')">多选题</a-button>&nbsp;
            <a-button @click="addQuestion('3')">文本题</a-button>
          </div>
          <a-button
            type="dashed"
            style="width: 100%"
            size="large"
            @click="showAddOp = !showAddOp"
          >
            <a-icon type="plus" /> 添加问题
          </a-button>
        </a-form-model-item>
        <a-form-model-item>
          <div style="display: flex;justify-content: space-between;">
            <a-form-model-item label="问卷截止日期" style="display: flex;">
              <a-date-picker
                v-model="dynamicValidateForm.endTime"
                style="width: 200px"
                format="YYYY-MM-DD HH:mm:ss"
                :disabled-date="disabledDate"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </a-form-model-item>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import moment from 'moment';

export default {
  name: 'questionModal',
  data() {
    return {
      selectIndex: '',
      selectOneIndex: '',
      editingIndex: '',
      dynamicValidateForm: {
        name: '问卷题目',
        listQuestionOptionDto: [],
        endTime: null
      },
      showAddOp: false,
      form: this.$form.createForm(this),
      title: '修改',
      width: 800,
      visible: false,
      model: {},
      confirmLoading: false,
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/questions/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/cont/questions/edit',
        detail: process.env.VUE_APP_CMS_CONTENT + '/cont/questions/selectpaper'
      }
    };
  },
  methods: {
    inputFocus(indexInner) {
      this.editingIndex = indexInner;
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input[0].focus();
        }
      });
    },
    add() {
      this.edit({});
    },
    edit(records) {
      this.visible = true;
      this.model = records;
      if (records.id) {
        this.dynamicValidateForm.id = records.id;
        this.$http
          .get(
            this.url.detail,
            {
              params: {
                id: records.id
              }
            },
            { headers: { 'Content-Type': 'application/json; charset=utf-8' } }
          )
          .then(res => {
            if (res.success) {
              let { result } = res;
              this.dynamicValidateForm.name = result.name;
              let listQuestionOptionDto = result.listQuestionOptionDto;
              listQuestionOptionDto.forEach(item => {
                item.questionOption = eval('(' + item.questionOption + ')');
              });
              this.dynamicValidateForm.listQuestionOptionDto = listQuestionOptionDto;
              this.dynamicValidateForm.endTime = result.endTime
                ? moment(record.endTime, 'YYYY-MM-DD HH:mm:ss')
                : null;
            } else {
              this.$message.warning(res.message);
            }
          });
      } else {
        this.dynamicValidateForm = {
          name: '问卷题目',
          listQuestionOptionDto: [],
          endTime: null
        };
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      this.$refs.dynamicValidateForm.validate(valid => {
        if (valid) {
          if (this.dynamicValidateForm.listQuestionOptionDto.length === 0) {
            this.$message.warning('请添加问题！');
            return false;
          }
          const that = this;
          // 触发表单验证
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }

          let endTime = this.dynamicValidateForm.endTime;
          endTime = endTime
            ? moment(endTime).format('YYYY-MM-DD HH:mm:ss')
            : '';
          let params = {
            ...this.dynamicValidateForm,
            endTime
          };
          this.$http
            .post(httpurl, params, {
              headers: { 'Content-Type': 'application/json; charset=utf-8' }
            })
            .then(res => {
              if (res.success) {
                this.$message.success(res.message);
                that.$emit('ok');
              } else {
                this.$message.warning(res.message);
              }
              this.close();
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCancel() {
      this.close();
    },
    moment,
    disabledDate(current) {
      return current && current < moment().endOf('day');
    },

    addDomain() {
      this.showAddOp = true;
    },
    addOneItem(item, index) {
      item.questionOption.push('');
    },
    removeItem(index) {
      if (this.dynamicValidateForm.listQuestionOptionDto.length < 2) {
        this.$confirm({
          title: '提示',
          content: '每份问卷至少一个问题！',
          okText: '确认',
          cancelText: '取消'
        });
      } else {
        this.dynamicValidateForm.listQuestionOptionDto.splice(index, 1);
      }
    },

    removeOneItem(item, index, questionType) {
      if (item.questionOption.length <= 2) {
        this.$confirm({
          title: '提示',
          content: '每个问题至少两个选项!',
          okText: '确认',
          cancelText: '取消'
        });
      } else {
        item.questionOption.splice(index, 1);
      }
    },
    addQuestion(questionType) {
      let obj = {
        questionName: '',
        questionType
      };
      if (questionType != '3') {
        obj.questionOption = ['', '', ''];
      } else {
        obj.questionOption = [''];
      }
      this.dynamicValidateForm.listQuestionOptionDto.push(obj);
      this.showAddOp = false;
    }
  }
};
</script>
<style lang="less" scoped>
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}
.item-form {
  padding: 20px;
  border-radius: 5px;
  &:hover {
    background: #f6f6f6;
  }
}
.item-input {
  width: 450px;
  margin-right: 10px;
}

.questionName-item {
  margin-bottom: 10px;
  .ant-input {
    font-weight: 500;
  }
}
.ant-input,
.questionName-item .ant-input {
  background: unset;
  border: none;
  &:focus {
    background: #fff;
    border: 1px solid #d9d9d9;
    box-shadow: unset;
  }
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
.add-options {
  margin-bottom: 10px;
  transition: height 1s;
}
</style>
